import { useAPIQuery, UserAccountApi } from "melco-shared-logic";

export const useMachineLicenseGetAssignment = () => {
    return useAPIQuery(UserAccountApi, ["machineLicenseGetAssignment"], async (api) => {
        const response = await api.accountGetMachineLicenseAssignment();

        return response ?? [];
    });
};